import React, { useEffect, useState } from 'react'
import {
   makeStyles,
   ListItem,
   ListItemText,
   ListItemIcon,
   Grid
} from '@material-ui/core'
import MaterialIcon from '../../materialIcon/materialIcon'
import { useStateValue } from 'context/store'
import Utils from 'utils/utils'
import clsx from 'clsx'
import NewIcon from 'components/commons/NewIcon'
import NewIconMainMenu from 'components/commons/NewIconMainMenu'
import DeviceHubNew from 'images/icons/subdomain/DeviceHubNew'

const useStyles = makeStyles(() => ({
   listItemIcon: {
      minWidth: '35px',
      position: 'relative'
   },
   listItemNew: {
      position: 'absolute',
      right: '10px',
      bottom: '9px'
   },
   subitemText: {
      font: 'normal normal normal 14px/19px Roboto',
      letterSpacing: '0px',
      paddingLeft: '4px'
   },
   selectedMainItem: {
      backgroundColor: '#3264DC08',
      color: '#3264DC'
   }
}))

const MainMenuItems = ({ submenu, openSecondaryMenu }) => {
   const classes = useStyles()
   const itemTitle = Utils.getNoSpaceTitle(submenu.title)
   const [newChidren, setNewChildren] = useState(false)
   const [{ mainMenuItemSelection }, dispatch] = useStateValue()

   const handleClick = submenu => {
      openSecondaryMenu(submenu)
      dispatch({ type: 'MAIN_MENU_ITEM_SELECTED', itemTitle })
   }

   useEffect(() => {
      submenu?.menus?.map(item => {
         if (item?.newOption) {
            return setNewChildren(true)
         }
         if (!item?.newOption) {
            item?.menus?.map(item2 => {
               if (item2?.newOption) {
                  return setNewChildren(true)
               }
               if (!item2?.newOption) {
                  item2?.manus?.map(item3 => {
                     if (item3?.newOption) {
                        return setNewChildren(true)
                     }
                  })
               }
            })
         }
      })
   }, [])
   return (
      <Grid
         key={submenu.id}
         className={
            mainMenuItemSelection?.currentState[itemTitle]
               ? classes.selectedMainItem
               : ''
         }
      >
         <ListItem button onClick={() => handleClick(submenu)}>
            <ListItemIcon
               className={clsx(classes.listItemIcon, {
                  [classes.selectedMainItem]:
                     mainMenuItemSelection?.currentState[itemTitle]
               })}
            >
               {submenu.icon === 'device_hub_new' ? (
                  <div style={{ paddingLeft: '2.2px' }}>
                     <DeviceHubNew color="#666666" />
                  </div>
               ) : (
                  <MaterialIcon
                     fill="outlined"
                     name={submenu.icon || 'select_all'}
                  />
               )}

               <div className={classes.listItemNew}>
                  {submenu?.newOption || newChidren ? (
                     <NewIconMainMenu />
                  ) : null}
               </div>
            </ListItemIcon>
            <ListItemText
               classes={{ primary: classes.subitemText }}
               primary={submenu.title}
            />
            {submenu?.newOption ? <NewIcon /> : null}
         </ListItem>
      </Grid>
   )
}

export default MainMenuItems
